import { getConsoleStyle as o } from "./styledLogs.js";
const a = async () => {
  const e = document.querySelectorAll('link[rel="stylesheet"]');
  for (const n of e)
    try {
      if ((await (await fetch(n.href)).text()).includes("--tw"))
        return !0;
    } catch (t) {
      console.warn(`Failed to fetch CSS file: ${n.href}`, t);
    }
  const i = document.querySelectorAll("style");
  for (const n of i)
    if (n.textContent?.includes("--tw"))
      return !0;
  return !1;
};
let s = !1;
(async () => {
  try {
    s = await a();
  } catch (e) {
    console.error("Error during Tailwind detection:", e);
  }
})();
setInterval(() => {
  if (s) {
    const e = [
      "TAILWIND DETECTED!!!",
      "Using Tailwind CSS in combination with the RIO UIKIT is strongly discouraged because it can lead to significant design and development issues.",
      "The RIO UIKIT is a component-driven design system with carefully crafted styles to ensure consistent branding and user experience.",
      "Tailwind CSS, as a utility-first framework, introduces inline styling that can conflict with the RIO UIKIT’s predefined component styles.",
      "This can result in overridden styles, broken layouts, inconsistent spacings, inconsistent design language, and increased maintenance complexity.",
      "Tailwind’s global reset styles may also disrupt the base styles of the RIO UIKIT, causing unintended visual changes.",
      "Furthermore, mixing the two systems creates unnecessary redundancy, increases CSS bundle size, and complicates debugging and future updates.",
      "To ensure a cohesive, maintainable, and professional design system, it is essential to rely solely on the RIO UIKIT and its customization options rather than introducing conflicting styling frameworks.",
      `WE MAY TECHNICALLY DISABLE TAILWIND FUNCTIONALITY IN THE FUTURE.
PLEASE DO NOT USE TAILWIND!`
    ].join(`

`);
    console.warn("%c%s", o(), e);
  }
}, 1e4);
export {
  a as doNotUseTailwind
};
//# sourceMappingURL=doNotUseTailwind.js.map
